import { yesNoSchema } from 'platform/forms-system/src/js/web-component-patterns';
import SponsorDisabilityPrefillInfo from '../../components/FormDescriptions/SponsorDisabilityPrefillInfo';
import SponsorDisabilityPrefillReview from '../../components/FormReview/SponsorDisabilityPrefillReview';
import {
  DEFAULT_TITLE_OPTS,
  hiddenFieldUI,
  titleWithRoleUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['eligibility--disability-title'];

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.sponsor),
    'ui:description': SponsorDisabilityPrefillInfo,
    'ui:objectViewField': SponsorDisabilityPrefillReview,
    'view:sponsorIsDisabled': hiddenFieldUI,
  },
  schema: {
    type: 'object',
    properties: {
      'view:sponsorIsDisabled': yesNoSchema,
    },
  },
};
